// Auto-gap: keys used in code but missing from zh-CN
export default {
  'pages.admin.providerCard.badge.commercialLicense': '商业授权',
  'pages.admin.providerCard.badge.sort': '序号 {n}',
  'pages.admin.providerCard.config.commercialLicense': '商业授权',
  'pages.admin.providerCard.config.funasrAddr': 'funasr uri',
  'pages.admin.providerCard.config.no': '否',
  'pages.admin.providerCard.config.yes': '是',
  'pages.admin.user.supplierCode': '授权编码',
  'pages.admin.user.supplierCode.label': '授权编码',
  'pages.admin.user.supplierCode.tooltip': '填写企业授权编码，非空即为该企业的管理账号；留空解除绑定',
  'pages.agents.delete.confirm.all': '确认删除该说话人及其所有样本?',
  'pages.agentSetting.asr.label': '语音识别模型',
  'pages.agentSetting.asr.placeholder': '选择语音识别（ASR）提供方',
  'pages.agentSetting.asr.required': '请选择 ASR 提供方',
  'pages.agentSetting.asr.tip': '与系统管理中已配置的 ASR 提供方一致；影响设备端语音识别管线。',
  'pages.agentSetting.asr.title': 'ASR · 语音识别',
  'pages.agentSetting.memory.clear.error': '记忆清除失败',
  'pages.agentSetting.memory.clear.success': '记忆已清除',
  'pages.agentSetting.memory.edit.error': '记忆更新失败',
  'pages.agentSetting.recognitionSpeed.fast': '快速',
  'pages.agentSetting.recognitionSpeed.normal': '正常',
  'pages.agentSetting.recognitionSpeed.slow': '耐心',
  'pages.agentSetting.tts.label': '语音合成模型',
  'pages.agentSetting.tts.title': 'TTS · 语音合成',
  'pages.common.confirm': '确定',
  'pages.devices.bridge.connectorOffline': '已绑定；电脑运行 SaiboAssistant 输入下方配对码即可',
  'pages.devices.bridge.copyPairCode': '复制配对码',
  'pages.devices.bridge.notConfigured': '设备未绑定或未关联智能体',
  'pages.devices.bridge.pairCode': '配对码',
  'pages.devices.bridge.ready': '已绑定智能体，Connector 在线',
  'pages.devices.bridge.runtime': '龙虾对话（设备端选择后自动检测）',
  'pages.devices.copy.iccidEmpty': 'ICCID 为空，无法复制',
  'pages.devices.copy.iccidSuccess': 'ICCID 已复制',
  'pages.devices.copy.macEmpty': 'MAC 地址为空，无法复制',
  'pages.devices.copy.pairCodeEmpty': '配对码为空，无法复制',
  'pages.devices.copy.pairCodeSuccess': '配对码已复制',
  'pages.devices.device.iccid': '物理网卡ICCID',
  'pages.knowledgeBase.chunks.actions.add': '新增切片',
  'pages.knowledgeBase.chunks.actions.delete': '删除',
  'pages.knowledgeBase.chunks.add.contentRequired': '请输入切片内容',
  'pages.knowledgeBase.chunks.add.emptyHint': '当前文档尚无切片时无法追加，请先完成索引或换页查看',
  'pages.knowledgeBase.chunks.add.error': '新增切片失败',
  'pages.knowledgeBase.chunks.add.modalHint': '内容将写入当前文档在向量库中的同一逻辑文档下，并自动完成向量化。',
  'pages.knowledgeBase.chunks.add.modalTitle': '新增切片',
  'pages.knowledgeBase.chunks.add.needAnchor': '当前页没有可用切片元数据，请刷新或从文档列表重新进入',
  'pages.knowledgeBase.chunks.add.placeholder': '输入新切片正文…',
  'pages.knowledgeBase.chunks.add.scopeHint': '「新增切片」需从文档列表进入本页（带文档上下文）。在全部切片视图下仅支持编辑与删除。',
  'pages.knowledgeBase.chunks.add.success': '新增切片成功',
  'pages.knowledgeBase.chunks.delete.confirmDesc': '删除后无法恢复，检索中将不再命中该段内容。',
  'pages.knowledgeBase.chunks.delete.confirmTitle': '确定删除该切片？',
  'pages.knowledgeBase.chunks.delete.error': '删除切片失败',
  'pages.knowledgeBase.chunks.delete.success': '已删除切片',
  'pages.settings.basicInfo.newNicknameRequired': '请输入新昵称',
  'pages.settings.basicInfo.nicknameChangeError': '昵称修改失败',
  'pages.settings.basicInfo.nicknameLength': '昵称长度为 2–20 个字符',
  'pages.settings.deleteAccount.error': '删除账号失败',
  'pages.settings.fetchProfile.error': '获取用户信息失败',
  'pages.settings.password.changeError': '密码修改失败',
  'pages.settings.password.changeSuccess': '密码修改成功',
  'pages.speaker.addSample': '增加样本',
  'pages.speaker.deleteSample': '删除样本',
  'pages.speaker.deleteSpeaker': '删除说话人',
  'pages.speaker.selectWavTip': '请选择一个wav文件',
  'pages.speaker.speakerList': '声纹说话人列表',
  'pages.voiceClone.colExtra': '扩展字段',
  'pages.voiceClone.colPath': '本地路径',

  'menu.admin.sub-page': '二级管理页',
  'pages.agentSetting.voiceType.groupClone': '我的克隆音色',
  'pages.agentSetting.voiceType.groupPreset': '系统预设音色',
  'pages.agentSetting.memory.longTerm.content.placeholder':
    '暂无 long_term_memory 内容，对话后会自动生成，也可点击编辑手动补充',
  'pages.agentSetting.memory.longTerm.content.editPlaceholder':
    '请输入 long_term_memory 内容，建议保持 JSON 格式',
  'pages.agentSetting.memory.longTerm.backToForm': '返回表单编辑',
  'pages.agentSetting.memory.longTerm.switchJson': '切换到 JSON 源码编辑',
  'pages.admin.providerCard.voices.count': '个',
  'pages.knowledgeBase.upload.success': '上传成功',
  'pages.knowledgeBase.upload.singleLimit': '当前版本仅支持一个文档，请先删除现有文档',
};
